export const GET_PAGE = 'GET_PAGE'
export const GET_PAGE_SUCCESS = 'GET_PAGE_SUCCESS'

export const GET_SUMMARY = 'GET_SUMMARY'
export const GET_SUMMARY_SUCCESS = 'GET_SUMMARY_SUCCESS'

export const GET_DISTANCE = 'GET_DISTANCE'
export const GET_DISTANCE_SUCCESS = 'GET_DISTANCE_SUCCESS'
